<template>
  <el-dialog :title="`Bạn chắc chắn muốn xóa tài liệu đã chọn?`" :visible="show">
    <div>Tài liệu sẽ bị xóa vĩnh viễn, bạn có muốn tiếp tục?</div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="show = false">Trở về</el-button>
      <el-button type="danger" @click="handleDeleteDocument">Xóa</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { apiDeleteGroupDocument } from '@/services/group_management_service'
import FAIcon from '@/components/common/FAIcon.vue'

export default {
  name: 'GroupDocumentDeleteModal',
  data() {
    return {
      show: false,
      document: document,
    }
  },
  components: { FAIcon },
  methods: {
    openModal(document) {
      this.document = document
      this.show = true
    },
    async handleDeleteDocument() {
      let res = await apiDeleteGroupDocument(this.document.groupId, [this.document.documentIds])
      if (res != null && res.status === 'SUCCESS') {
        this.$message.success(res.description)
        this.$data.show = false
        this.$emit('success')
      } else {
        this.$message.error('Có lỗi xảy ra')
      }
    },
  },
}
</script>
